import type { MasteryMapDomain } from '../model/types/mastery-map/interfaces'

const STRAND_TITLES: Record<string, string> = {
  CC: 'Counting & Cardinality',
  OA: 'Operations & Algebraic Thinking',
  NBT: 'Number & Operations in Base Ten',
  NF: 'Number & Operations: Fractions',
  MD: 'Measurement & Data',
  G: 'Geometry',
  RP: 'Ratios & Proportional Relationships',
  NS: 'The Number System',
  EE: 'Expressions & Equations',
  SP: 'Statistics & Probability',
  F: 'Functions',
  RL: 'Reading: Literature',
  RI: 'Reading: Informational Text',
  RF: 'Reading: Foundational Skills',
  W: 'Writing',
  SL: 'Speaking & Listening',
  L: 'Language',
}

const STRAND_CODE_SEGMENTS = 2

/** `3.G.A.1` -> `3.G`, `RL.3.1` -> `RL.3`: the same rule as tutor-app's `getDomainCode`. */
export const getStrandCode = (skillCode: string): string =>
  skillCode.split('.').slice(0, STRAND_CODE_SEGMENTS).join('.')

const getTitleByToken = (strandCode: string): string | null => {
  const token = strandCode.split('.').find(segment => segment in STRAND_TITLES)

  return token ? STRAND_TITLES[token] ?? null : null
}

export const getStrandTitle = (strandCode: string, domains: MasteryMapDomain[]): string =>
  domains.find(domain => domain.code === strandCode)?.label
  ?? getTitleByToken(strandCode)
  ?? strandCode
